module.exports = __webpack_public_path__ + "static/img/necklace.5b403cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/necklace/necklace.png
// module id = 4Ql0
// module chunks = 1